(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[397],{

/***/ 17285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 49546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _ampContext = __webpack_require__(17285);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react["default"].useContext(_ampContext.AmpStateContext));
}

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 16505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__(930);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _sideEffect = _interopRequireDefault(__webpack_require__(70148));

var _ampContext = __webpack_require__(17285);

var _headManagerContext = __webpack_require__(60523);

var _amp = __webpack_require__(49546);

var _utils = __webpack_require__(67206);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headElements List of multiple <Head> instances
 */


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react["default"].Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !props.inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _objectSpread({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 70148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__(7980);

var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _assertThisInitialized = __webpack_require__(92191);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var isServer = false;

var _class = /*#__PURE__*/function (_react$Component) {
  _inherits(_class, _react$Component);

  var _super = _createSuper(_class);

  function _class(props) {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this, props);

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances["delete"](this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _class;
}(_react.Component);

exports["default"] = _class;

/***/ }),

/***/ 33784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ChartAnnotation; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var ChartAnnotation = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ChartAnnotation",
  componentId: "sc-1fwykuv-0"
})(["font-size:12px;color:", ";line-height:1.9;@media screen and (max-width:1047px){font-size:11px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 13168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ SpAccordion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _components_elements_Line__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var SpAccordion = function SpAccordion(_ref) {
  var title = _ref.title,
      children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isExpand = _useState[0],
      setIsExpand = _useState[1];

  var id = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Button, {
      onClick: function onClick() {
        return setIsExpand(function (prev) {
          return !prev;
        });
      },
      "aria-expanded": isExpand,
      "aria-controls": id,
      children: [title, isExpand ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CloseIcon, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(OpenIcon, {})]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SpLine, {
      color: "grey",
      weight: 1,
      direction: "horizon"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Content, {
      id: id,
      children: children
    })]
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SpAccordion__Wrapper",
  componentId: "sc-1h04sez-0"
})(["@media screen and (max-width:1047px){width:100%;background:", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundGrey */ .r.colors.backgroundGrey);
var Button = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "SpAccordion__Button",
  componentId: "sc-1h04sez-1"
})(["display:none;@media screen and (max-width:1047px){font-size:16px;font-weight:bold;width:100%;padding:15px 12px 16px;display:flex;align-items:center;justify-content:space-between;color:", ";background:", ";border:none;border-radius:8px;&[aria-expanded='true']{border-bottom-left-radius:0;border-bottom-right-radius:0;}&[aria-expanded='false'] ~ div{height:0;padding-top:0;padding-bottom:0;opacity:0;overflow:hidden;pointer-events:none;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundGrey */ .r.colors.backgroundGrey);
var SpLine = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_elements_Line__WEBPACK_IMPORTED_MODULE_2__/* .Line */ .x).withConfig({
  displayName: "SpAccordion__SpLine",
  componentId: "sc-1h04sez-2"
})(["display:none;@media screen and (max-width:1047px){display:block;margin:0 12px;}"]);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SpAccordion__Content",
  componentId: "sc-1h04sez-3"
})(["height:100%;@media screen and (max-width:1047px){transition:0.3s;height:auto;padding:16px 12px;border-top-right-radius:0;border-top-left-radius:0;}"]);
var OpenIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdAdd */ .x06).withConfig({
  displayName: "SpAccordion__OpenIcon",
  componentId: "sc-1h04sez-4"
})(["font-size:30px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);
var CloseIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdRemove */ .eqC).withConfig({
  displayName: "SpAccordion__CloseIcon",
  componentId: "sc-1h04sez-5"
})(["font-size:30px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);

/***/ }),

/***/ 55919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "Tr": function() { return /* binding */ Tr; },
/* harmony export */   "hr": function() { return /* binding */ Thead; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "p3": function() { return /* binding */ Tbody; },
/* harmony export */   "wA": function() { return /* binding */ TbodyWithThreeColumnHeadings; }
/* harmony export */ });
/* unused harmony export TbodyWithTwoColumnHeadings */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Table = function Table(_ref) {
  var labelId = _ref.labelId,
      label = _ref.label,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableWrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTable, {
      "aria-labelledby": labelId,
      "aria-label": label,
      children: children
    })
  });
};
var TableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Table__TableWrapper",
  componentId: "sc-173bbn3-0"
})(["overflow-y:auto;"]);
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].table.withConfig */ .ZP.table.withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-173bbn3-1"
})(["border-collapse:separate;width:100%;"]);
var Thead = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
  displayName: "Table__Thead",
  componentId: "sc-173bbn3-2"
})(["> tr:first-of-type > th:first-of-type{position:sticky;left:0;border-left:1px solid ", ";}> tr:first-of-type > th{border-top:1px solid ", ";}> tr > th{word-break:keep-all;&.AnalystCoverage{word-break:normal;}}tr > th:first-of-type{border-left:1px solid ", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var Tbody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__Tbody",
  componentId: "sc-173bbn3-3"
})(["> tr > th{border-left:1px solid ", ";}> tr > th:first-of-type{position:sticky;left:0;}> tr > td:last-of-type{border-right:1px solid ", ";}@media screen and (max-width:1047px){> tr > th{min-width:30vw;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var TbodyWithTwoColumnHeadings = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__TbodyWithTwoColumnHeadings",
  componentId: "sc-173bbn3-4"
})(["> tr > th:first-of-type{position:sticky;left:", ";}> tr > th[rowspan]{border-left:1px solid ", ";position:sticky;left:0;min-width:", ";}> tr > th[rowspan] + th{position:sticky;left:", ";}@media screen and (max-width:1047px){> tr > th[rowspan] + th{min-width:14vw;position:sticky;}}&.StickyItem{position:sticky;top:0;z-index:10;}"], function (_ref2) {
  var firstHeadWidth = _ref2.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref3) {
  var firstHeadWidth = _ref3.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref4) {
  var firstHeadWidth = _ref4.firstHeadWidth;
  return firstHeadWidth;
});
var TbodyWithThreeColumnHeadings = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tbody.withConfig */ .ZP.tbody.withConfig({
  displayName: "Table__TbodyWithThreeColumnHeadings",
  componentId: "sc-173bbn3-5"
})(["> tr > th:nth-last-of-type(1){min-width:85px;position:sticky;left:calc(", " + ", ");}> tr > th:nth-last-of-type(2){width:", ";min-width:", ";position:sticky;left:", ";border-left:1px solid ", ";}> tr > th:nth-last-of-type(3){width:", ";min-width:", ";position:sticky;left:0px;border-left:1px solid ", ";}@media screen and (max-width:1047px){> tr > th:nth-last-of-type(1){min-width:14vw;position:sticky;}}&.StickyItem{position:sticky;top:0;z-index:10;}"], function (_ref5) {
  var firstHeadWidth = _ref5.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref6) {
  var secondHeadWidth = _ref6.secondHeadWidth;
  return secondHeadWidth || '0px';
}, function (_ref7) {
  var secondHeadWidth = _ref7.secondHeadWidth;
  return secondHeadWidth || '60px';
}, function (_ref8) {
  var secondHeadWidth = _ref8.secondHeadWidth;
  return secondHeadWidth || '60px';
}, function (_ref9) {
  var firstHeadWidth = _ref9.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref10) {
  var firstHeadWidth = _ref10.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref11) {
  var firstHeadWidth = _ref11.firstHeadWidth;
  return firstHeadWidth;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
var Tr = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
  displayName: "Table__Tr",
  componentId: "sc-173bbn3-6"
})([""]);
var Th = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].th.withConfig */ .ZP.th.withConfig({
  displayName: "Table__Th",
  componentId: "sc-173bbn3-7"
})(["padding:13px 5px 15px 5px;font-size:16px;text-align:", ";vertical-align:middle;border-right:", ";border-bottom:1px solid ", ";line-height:1.2;background:", ";@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}> tr > th[rowspan] + th{position:sticky;left:", ";}font-weight:", ";"], function (_ref12) {
  var textAlign = _ref12.textAlign;
  return textAlign !== null && textAlign !== void 0 ? textAlign : 'center';
}, function (_ref13) {
  var noBorder = _ref13.noBorder;
  return noBorder ? 'none' : "1px solid ".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder, function (_ref14) {
  var color = _ref14.color;
  return color === 'primary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.primary */ .r.colors.th.primary : color === 'secondary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.secondary */ .r.colors.th.secondary : color === 'darkest' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.darkest */ .r.colors.th.darkest : color === 'accentYellow' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.accentYellow */ .r.colors.th.accentYellow : color === 'holiday' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.accentYellow */ .r.colors.th.accentYellow : color === 'tertiary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.tertiary */ .r.colors.th.tertiary : color === 'quaternary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.quaternary */ .r.colors.th.quaternary : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th["default"] */ .r.colors.th["default"];
}, function (_ref15) {
  var firstHeadWidth = _ref15.firstHeadWidth;
  return firstHeadWidth;
}, function (_ref16) {
  var isBold = _ref16.isBold;
  return isBold ? 'bold' : 'normal';
});
var Td = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].td.withConfig */ .ZP.td.withConfig({
  displayName: "Table__Td",
  componentId: "sc-173bbn3-8"
})(["padding:13px 5px 15px 5px;font-size:16px;line-height:1.2;text-align:", ";background:", ";vertical-align:middle;border-right:", ";border-bottom:1px solid ", ";@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}"], function (_ref17) {
  var textAlign = _ref17.textAlign;
  return textAlign !== null && textAlign !== void 0 ? textAlign : 'right';
}, function (_ref18) {
  var color = _ref18.color;
  return color === 'primary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.primary */ .r.colors.th.primary : color === 'secondary' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.th.secondary */ .r.colors.th.secondary : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.td["default"] */ .r.colors.td["default"];
}, function (_ref19) {
  var noBorder = _ref19.noBorder;
  return noBorder ? 'none' : "1px solid ".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.tableBorder */ .r.colors.tableBorder);

/***/ }),

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 3319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Os": function() { return /* binding */ AHeading; },
/* harmony export */   "V": function() { return /* binding */ CHeading; },
/* harmony export */   "Zg": function() { return /* binding */ BHeading; },
/* harmony export */   "ac": function() { return /* binding */ DHeading; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var AHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__AHeading",
  componentId: "sc-i66uaa-0"
})(["font-size:28px;font-weight:700;line-height:1.2;color:", ";border-bottom:1px solid ", ";padding-bottom:22px;margin-bottom:50px;@media screen and (max-width:1047px){font-size:19px;padding-bottom:10px;margin-bottom:30px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey);
var BHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "Heading__BHeading",
  componentId: "sc-i66uaa-1"
})(["font-size:24px;font-weight:700;line-height:140%;color:", ";margin-bottom:36px;@media screen and (max-width:1047px){font-size:20px;line-height:130%;margin-bottom:26px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var CHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Heading__CHeading",
  componentId: "sc-i66uaa-2"
})(["font-size:18px;font-weight:700;line-height:140%;margin-bottom:20px;@media screen and (max-width:1047px){font-size:16px;line-height:130%;margin-bottom:18px;}"]);
var DHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__DHeading",
  componentId: "sc-i66uaa-3"
})(["font-size:32px;font-weight:700;line-height:100%;color:", ";@media screen and (max-width:1047px){font-size:24px;line-height:130%;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 82319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/utils/enroutes.ts
var enroutes = __webpack_require__(9058);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
// EXTERNAL MODULE: ./src/components/elements/SpAccordion/index.tsx
var SpAccordion = __webpack_require__(13168);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enlayouts/SiteMap/IrSiteMapLink/IrSiteMap.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var SiteLink = function SiteLink(_ref) {
  var name = _ref.name,
      path = _ref.path,
      newWindow = _ref.newWindow;

  var link = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
    href: path,
    target: newWindow ? '_blank' : undefined,
    rel: newWindow ? 'noopener noreferrer' : undefined,
    children: name
  });

  if (path.endsWith('/ir/financial/chart/')) return link;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: path,
    passHref: true,
    children: link
  });
};

var IrSiteMap = function IrSiteMap(_ref2) {
  var parent = _ref2.parent,
      subdirectories = _ref2.subdirectories,
      _ref2$isLast = _ref2.isLast,
      isLast = _ref2$isLast === void 0 ? false : _ref2$isLast;

  if (isLast) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SpAccordion/* SpAccordion */.k, {
      title: parent.name,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FullBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ParentName, {
          children: parent.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PcLine, {
          color: "grey",
          weight: 1,
          direction: "horizon"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubdirectoryList, {
          direction: "row",
          children: subdirectories.map(function (site) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiteLink, _objectSpread({}, site))
            }, site.path);
          })
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpAccordion/* SpAccordion */.k, {
    title: parent.name,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ParentName, {
        children: parent.path ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: parent.path,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
            children: parent.name
          })
        }) : parent.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 0,
          pc: 14
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PcLine, {
        color: "grey",
        weight: 1,
        direction: "horizon"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 0,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubdirectoryList, {
        direction: "column",
        children: subdirectories.map(function (site) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiteLink, _objectSpread({}, site))
          }, site.name);
        })
      })]
    })
  });
};
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__Box",
  componentId: "sc-pz1tvd-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;padding:26px 20px 32px;@media screen and (max-width:1047px){width:100%;padding:0;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var FullBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__FullBox",
  componentId: "sc-pz1tvd-1"
})(["width:1040px;padding:26px 20px 32px;background:", ";border-radius:8px;display:flex;justify-content:space-between;align-items:center;@media screen and (max-width:1047px){display:block;width:100%;padding:0;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var PcLine = (0,styled_components_browser_esm/* default */.ZP)(Line/* Line */.x).withConfig({
  displayName: "IrSiteMap__PcLine",
  componentId: "sc-pz1tvd-2"
})(["@media screen and (max-width:1047px){display:none;}"]);
var ParentName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMap__ParentName",
  componentId: "sc-pz1tvd-3"
})(["font-size:20px;font-weight:700;line-height:120%;@media screen and (max-width:1047px){display:none;}"]);
var SubdirectoryList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "IrSiteMap__SubdirectoryList",
  componentId: "sc-pz1tvd-4"
})(["display:flex;row-gap:16px;column-gap:50px;flex-direction:", ";", " > li{font-size:16px;line-height:120%;}@media screen and (max-width:1047px){gap:14px;flex-direction:column;> li{font-size:14px;}}"], function (_ref3) {
  var direction = _ref3.direction;
  return direction;
}, function (_ref4) {
  var direction = _ref4.direction;
  return direction === 'row' && 'margin-right: 120px;';
});
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "IrSiteMap__StyledLink",
  componentId: "sc-pz1tvd-5"
})(["color:", ";display:block;width:100%;&:hover{text-decoration:underline;color:", ";}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
;// CONCATENATED MODULE: ./src/components/enlayouts/SiteMap/IrSiteMapLink/index.tsx





var IrSiteMapLink = function IrSiteMapLink() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SiteMapList, {
      minHeight: "regular",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_MANAGE_ROUTE.path */.Xp.path,
          name: enroutes/* IR_MANAGE_ROUTE.name */.Xp.name
        },
        subdirectories: enroutes/* IR_MANAGE_ROUTE.subdirectories */.Xp.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_GOVERNANCE_ROUTE.path */.by.path,
          name: enroutes/* IR_GOVERNANCE_ROUTE.name */.by.name
        },
        subdirectories: enroutes/* IR_GOVERNANCE_ROUTE.subdirectories */.by.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_FINANCIAL_ROUTE.path */.Oh.path,
          name: enroutes/* IR_FINANCIAL_ROUTE.name */.Oh.name
        },
        subdirectories: enroutes/* IR_FINANCIAL_ROUTE.subdirectories */.Oh.subdirectories
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SiteMapList, {
      minHeight: "high",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_LIBRARY_ROUTE.path */.C_.path,
          name: enroutes/* IR_LIBRARY_ROUTE.name */.C_.name
        },
        subdirectories: enroutes/* IR_LIBRARY_ROUTE.subdirectories */.C_.subdirectories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
        parent: {
          path: enroutes/* IR_STOCK_ROUTE.path */.aQ.path,
          name: enroutes/* IR_STOCK_ROUTE.name */.aQ.name
        },
        subdirectories: enroutes/* IR_STOCK_ROUTE.subdirectories */.aQ.subdirectories
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMap, {
      parent: {
        name: enroutes/* IR_OTHER_ROUTE.name */.yE.name
      },
      subdirectories: enroutes/* IR_OTHER_ROUTE.subdirectories */.yE.subdirectories,
      isLast: true
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMapLink__Wrapper",
  componentId: "sc-wp9cdp-0"
})(["display:flex;flex-direction:column;gap:46px;@media screen and (max-width:1047px){gap:14px;}"]);
var SiteMapList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IrSiteMapLink__SiteMapList",
  componentId: "sc-wp9cdp-1"
})(["display:flex;gap:46px;height:100%;@media screen and (max-width:1047px){flex:1;flex-direction:column;gap:14px;}"]);
;// CONCATENATED MODULE: ./src/components/enlayouts/Ir/Footer.tsx





var Footer = function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* DHeading */.ac, {
      children: "IR Site Map"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 60
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IrSiteMapLink, {})]
  });
};
;// CONCATENATED MODULE: ./src/components/enlayouts/Ir/index.tsx





var Layout = function Layout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 140
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
};
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__Container",
  componentId: "sc-baigr5-0"
})(["width:1040px;margin:94px auto 130px;@media screen and (max-width:1047px){margin:40px auto 120px;width:100%;padding:0 20px;}"]);

/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Os": function() { return /* binding */ AHeading; },
/* harmony export */   "V": function() { return /* binding */ CHeading; },
/* harmony export */   "Zg": function() { return /* binding */ BHeading; },
/* harmony export */   "ac": function() { return /* binding */ DHeading; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var AHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__AHeading",
  componentId: "sc-ywkeww-0"
})(["font-size:28px;font-weight:700;line-height:1.2;color:", ";border-bottom:1px solid ", ";padding-bottom:22px;margin-bottom:50px;@media screen and (max-width:1047px){font-size:19px;padding-bottom:10px;margin-bottom:30px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey);
var BHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "Heading__BHeading",
  componentId: "sc-ywkeww-1"
})(["font-size:24px;font-weight:700;line-height:140%;color:", ";margin-bottom:36px;@media screen and (max-width:1047px){font-size:20px;line-height:130%;margin-bottom:26px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var CHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Heading__CHeading",
  componentId: "sc-ywkeww-2"
})(["font-size:18px;font-weight:700;line-height:140%;margin-bottom:20px;@media screen and (max-width:1047px){font-size:16px;line-height:130%;margin-bottom:18px;}"]);
var DHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "Heading__DHeading",
  componentId: "sc-ywkeww-3"
})(["font-size:32px;font-weight:700;line-height:100%;color:", ";@media screen and (max-width:1047px){font-size:24px;line-height:130%;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 37417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ AnotationText; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32125);

var AnotationText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AnotationText",
  componentId: "sc-1kqso6a-0"
})(["font-size:16px;line-height:190%;@media screen and (max-width:1047px){font-size:15px;line-height:180%;}"]);

/***/ }),

/***/ 63083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ SituationPage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Stock/Situation/ChartComponent.tsx




var ChartComponent = function ChartComponent(_ref) {
  var items = _ref.items;
  var data = (0,react.useMemo)(function () {
    if (items.length === 0) return [];
    return (0,toConsumableArray/* default */.Z)(items[0].ownershipBreakdownList).sort(function (a, b) {
      return a.sort - b.sort;
    }).map(function (item) {
      return {
        y: item.ratio,
        name: item.name_en
      };
    });
  }, [items]);
  (0,react.useEffect)(function () {
    if (window.Highcharts) {
      var Highcharts = window.Highcharts;
      Highcharts.wrap(Highcharts.seriesTypes.pie.prototype, "drawDataLabels", function (p) {
        var xOffset = 5;
        var yOffset = 12;
        p.call(this);
        Highcharts.each(this.points, function (p) {
          if (p.dataLabel && p.connector) {
            p.connector.attr({
              d: ["M", p.dataLabel._pos.x + (p.labelPos[6] === "left" ? -xOffset : xOffset), p.dataLabel._pos.y + yOffset, "L", p.labelPos[4], p.labelPos[5]]
            });
          }
        });
      });
      Highcharts.chart('container', {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          fontFamily: '"Noto Sans JP",Arial,sans-serif'
        },
        credits: {
          enabled: false
        },
        title: {
          text: "Percentage of Number of Shares Held",
          verticalAlign: "top",
          align: "center",
          useHTML: true,
          style: {
            lineHeight: "1.6",
            fontWeight: "700"
          }
        },
        tooltip: {
          enabled: false,
          pointFormat: "{series.name}: {point.percentage:.1f}%"
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            colors: ["#3783C4", // 1. 金融機関
            "#569CD8", // 2. 金融機関取引業者
            "#449330", // 3. その他の法人
            "#6BA65D", // 4. 外国法人等
            "#002D65", // 5. 自己株式
            "#8DBF80" // 6. 個人その他
            ],
            borderWidth: 1,
            size: "57%",
            borderColor: "#efefef",
            dataLabels: {
              useHTML: true,
              enabled: true,
              color: "#222",
              connectorWidth: 2,
              distance: 20,
              connectorColor: "#999999",
              format: "{point.name}:<br> {point.percentage:.2f} %",
              style: {
                fontSize: "10px;",
                fontWeight: "normal"
              }
            }
          }
        },
        series: [{
          name: "",
          colorByPoint: true,
          data: data
        }]
      });
    }
  }, [data]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: {
      width: "100%",
      overflowX: "auto"
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "container",
      style: {
        minWidth: "600px",
        width: "100%"
      }
    })
  });
};

/* harmony default export */ var Situation_ChartComponent = (ChartComponent);
// EXTERNAL MODULE: ./src/components/elements/Table/index.tsx
var Table = __webpack_require__(55919);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Stock/Situation/LargeShareholderTable.tsx





var LargeShareholderTable = function LargeShareholderTable(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table/* Table */.iA, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Table/* Thead */.hr, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
              color: 'tertiary',
              textAlign: "center",
              children: "Name"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
              color: 'tertiary',
              textAlign: "center",
              children: "Number of Shares Held"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
              color: 'tertiary',
              textAlign: "center",
              children: "Shareholdings Ratio"
            })]
          }), items[0].LargeShareholderList.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: 'tertiary',
                textAlign: "left",
                children: item.name_en
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: 'quaternary',
                textAlign: "right",
                children: item.shares
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: 'quaternary',
                textAlign: "right",
                children: item.ratio
              })]
            }, item._id);
          })]
        })
      })
    })
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LargeShareholderTable__Wrapper",
  componentId: "sc-1ilplco-0"
})(["overflow-y:auto;border-collapse:separate;width:100%;thead{> tr:first-of-type > th:first-of-type{position:sticky;left:auto;border-left:1px solid ", ";}> tr:first-of-type > th{border-top:1px solid ", ";}> tr > th{word-break:keep-all;}}tbody{> tr > th{border-left:1px solid ", ";}> tr > th:first-of-type{position:sticky;left:0;}> tr > td:last-of-type{border-right:1px solid ", ";}@media screen and (max-width:1047px){> tr > th{min-width:30vw;}}}th{padding:14px 14px 16px 14px;vertical-align:middle;line-height:1.2;border-right:1px solid ", ";border-bottom:1px solid ", ";font-size:16px;&[data-align='center']{text-align:center;}&[data-align='right']{text-align:right;}&[data-align='left']{text-align:left;}&[data-hasborder='false']{border-right:none;}@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}&[data-bgcolor='primary']{background:", ";}&[data-bgcolor='secondary']{background:", ";}&[data-bgcolor='quaternary']{background:", ";}&[data-bgcolor='darkest']{background:", ";}}td{text-align:right;background:", ";font-size:16px;padding:14px 14px 16px 14px;vertical-align:middle;line-height:1.2;border-right:1px solid ", ";border-bottom:1px solid ", ";&[data-align='center']{text-align:center;}&[data-align='right']{text-align:right;}&[data-align='left']{text-align:left;}&[data-hasborder='false']{border-right:none;}@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}&[data-bgcolor='primary']{background:", ";}&[data-bgcolor='secondary']{background:", ";}&[data-bgcolor='tertiary']{background:", ";}&[data-bgcolor='darkest']{background:", ";}}"], theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.th.primary */.r.colors.th.primary, theme/* theme.colors.th.secondary */.r.colors.th.secondary, theme/* theme.colors.th.quaternary */.r.colors.th.quaternary, theme/* theme.colors.th.darkest */.r.colors.th.darkest, theme/* theme.colors.td.default */.r.colors.td["default"], theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.th.primary */.r.colors.th.primary, theme/* theme.colors.th.secondary */.r.colors.th.secondary, theme/* theme.colors.th.tertiary */.r.colors.th.tertiary, theme/* theme.colors.th.darkest */.r.colors.th.darkest);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Stock/Situation/StatusSharesTable.tsx





var StatusSharesTable = function StatusSharesTable(_ref) {
  var items = _ref.items;
  var list = items[0].stockTotalList;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StatusSharesTable_Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table/* Table */.iA, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table/* Thead */.hr, {
          children: list.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(Table.Tr, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: 'tertiary',
                textAlign: "left",
                children: item.stockName_en
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Table.Th, {
                color: 'quaternary',
                textAlign: "right",
                children: formatNumber(item.stockValue)
              })]
            }, index);
          })
        })
      })
    })
  });
};

var formatNumber = function formatNumber(num) {
  return num.toLocaleString();
};

var StatusSharesTable_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StatusSharesTable__Wrapper",
  componentId: "sc-1ggj11v-0"
})(["overflow-y:auto;border-collapse:separate;width:100%;thead{> tr:first-of-type > th:first-of-type{position:sticky;left:0;border-left:1px solid ", ";}> tr:first-of-type > th{border-top:1px solid ", ";}> tr > th{word-break:keep-all;}}tbody{> tr > th{border-left:1px solid ", ";}> tr > th:first-of-type{position:sticky;left:0;}> tr > td:last-of-type{border-right:1px solid ", ";}@media screen and (max-width:1047px){> tr > th{min-width:30vw;}}}th{padding:14px 14px 16px 14px;vertical-align:middle;line-height:1.2;border-right:1px solid ", ";border-bottom:1px solid ", ";font-size:16px;&[data-align='center']{text-align:center;}&[data-align='right']{text-align:right;}&[data-align='left']{text-align:left;}&[data-hasborder='false']{border-right:none;}@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}&[data-bgcolor='primary']{background:", ";}&[data-bgcolor='secondary']{background:", ";}&[data-bgcolor='quaternary']{background:", ";}&[data-bgcolor='darkest']{background:", ";}}td{text-align:right;background:", ";font-size:16px;padding:14px 14px 16px 14px;vertical-align:middle;line-height:1.2;border-right:1px solid ", ";border-bottom:1px solid ", ";&[data-align='center']{text-align:center;}&[data-align='right']{text-align:right;}&[data-align='left']{text-align:left;}&[data-hasborder='false']{border-right:none;}@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:15px;}&[data-bgcolor='primary']{background:", ";}&[data-bgcolor='secondary']{background:", ";}&[data-bgcolor='tertiary']{background:", ";}&[data-bgcolor='darkest']{background:", ";}}"], theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.th.primary */.r.colors.th.primary, theme/* theme.colors.th.secondary */.r.colors.th.secondary, theme/* theme.colors.th.quaternary */.r.colors.th.quaternary, theme/* theme.colors.th.darkest */.r.colors.th.darkest, theme/* theme.colors.td.default */.r.colors.td["default"], theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.th.primary */.r.colors.th.primary, theme/* theme.colors.th.secondary */.r.colors.th.secondary, theme/* theme.colors.th.tertiary */.r.colors.th.tertiary, theme/* theme.colors.th.darkest */.r.colors.th.darkest);
// EXTERNAL MODULE: ./src/components/elements/ChartAnnotation/index.tsx
var ChartAnnotation = __webpack_require__(33784);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Mpocket/AnotationText.tsx
var AnotationText = __webpack_require__(37417);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Stock/Situation/index.tsx
















var SituationPage = function SituationPage(_ref) {
  var stockSituation = _ref.stockSituation,
      stockSituationOwnership = _ref.stockSituationOwnership,
      stockSituationPrincipal = _ref.stockSituationPrincipal;
  // useMpocketScript('//irpocket.com/141A/irpocket/ir-stock-situation_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-stock-situation.js')
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      enTitleText: "Stock Situation",
      subTitleText: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
      children: "Shares of Common Stock"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PublicationDate, {
      children: formatDate(stockSituation[0].statusSharesDate)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 6,
        pc: 10
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StatusSharesTable, {
      items: stockSituation
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 50,
        pc: 80
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnotationText/* AnotationText */.L, {
      dangerouslySetInnerHTML: {
        __html: stockSituation[0].statusSharesFootnotes_en
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 100
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
      children: "Ownership Breakdown"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PublicationDate, {
      children: formatDate(stockSituationOwnership[0].OwnershipBreakdownDate)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OwnerChart, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Situation_ChartComponent, {
        items: stockSituationOwnership
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Legend, {
        id: "irp-highlight-table-situation3_en"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 80
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
      children: "Principal Shareholders"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PublicationDate, {
      children: formatDate(stockSituationPrincipal[0].LargeShareholderDate)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 6,
        pc: 10
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LargeShareholderTable, {
      items: stockSituationPrincipal
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnotationText/* AnotationText */.L, {
      dangerouslySetInnerHTML: {
        __html: stockSituationPrincipal[0].principalShareholdersFootnotes_en
      }
    })]
  });
};

var formatDate = function formatDate(date) {
  return new Date(date).toLocaleDateString("en-US", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "long",
    day: "numeric"
  });
};

SituationPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir'
  }, {
    name: 'Stock Information',
    path: '/en/ir/stock'
  }, {
    name: 'Stock Situation',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Stock Situation",
      description: "Number of shares issued and number of shareholders.",
      ogp: {
        url: 'en/ir/stock/situation'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var OwnerChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Situation__OwnerChart",
  componentId: "sc-8qxv6e-0"
})(["display:flex;align-items:center;@media screen and (max-width:1047px){flex-direction:column;}"]);
var Legend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Situation__Legend",
  componentId: "sc-8qxv6e-1"
})(["tr::before{content:'';display:inline-block;height:1rem;width:1rem;vertical-align:-2px;}tr:first-of-type::before{background-color:", ";}tr:nth-of-type(2)::before{background-color:", ";}tr:nth-of-type(3)::before{background-color:", ";}tr:nth-of-type(4)::before{background-color:", ";}tr:nth-of-type(5)::before{background-color:", ";}tr:nth-of-type(6)::before{background-color:", ";}th{text-align:left;padding:1rem;position:relative;::after{content:':';position:absolute;right:0;display:inline-block;}}td:first-of-type{text-align:right;padding:1rem;}"], theme/* theme.colors.chart.owner.bank */.r.colors.chart.owner.bank, theme/* theme.colors.chart.owner.financialInstrumentsDealer */.r.colors.chart.owner.financialInstrumentsDealer, theme/* theme.colors.chart.owner.otherCorporation */.r.colors.chart.owner.otherCorporation, theme/* theme.colors.chart.owner.foreignCorporation */.r.colors.chart.owner.foreignCorporation, theme/* theme.colors.chart.owner.treasuryStock */.r.colors.chart.owner.treasuryStock, theme/* theme.colors.chart.owner.individual */.r.colors.chart.owner.individual);
var PublicationDate = (0,styled_components_browser_esm/* default */.ZP)(ChartAnnotation/* ChartAnnotation */.z).withConfig({
  displayName: "Situation__PublicationDate",
  componentId: "sc-8qxv6e-2"
})(["text-align:right;"]);
;// CONCATENATED MODULE: ./src/pages/en/ir/stock/situation/index.tsx
var __N_SSG = true;


/***/ }),

/***/ 30137:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/stock/situation",
      function () {
        return __webpack_require__(63083);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,9774,2888,179], function() { return __webpack_exec__(30137); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);